export default __webpack_public_path__ + "static/media/386.bd5b478a.png";